export const TKeyCredits = {
  CREDITS_SHARED_TITLE: "CREDITS_SHARED_TITLE",
  CREDITS_SHARED_TEXT: "CREDITS_SHARED_TEXT",
  CREDITS_BUY: "CREDITS_BUY",
  CREDITS_LABEL: "CREDITS_LABEL",
  CREDITS_DURATION_HINT: "CREDITS_DURATION_HINT",
  CREDITS_PER_UNIT: "CREDITS_PER_UNIT",
  CREDITS_TOTAL_HT: "CREDITS_TOTAL_HT",
  CREDITS_PACK_SELECT: "CREDITS_PACK_SELECT",
  CREDITS_CHOOSE_PACK: "CREDITS_CHOOSE_PACK",
  CREDITS_SECURE_PAYMENT: "CREDITS_SECURE_PAYMENT",
  CREDITS_STRIPE: "CREDITS_STRIPE",
  CREDITS_INSTANT_TITLE: "CREDITS_INSTANT_TITLE",
  CREDITS_INSTANT_SUBTITLE: "CREDITS_INSTANT_SUBTITLE",
  CREDITS_NO_COMMITMENT: "CREDITS_NO_COMMITMENT",
  CREDITS_ONE_TIME: "CREDITS_ONE_TIME",
  CREDITS_STRIPE_PRODUCT_NAME: "CREDITS_STRIPE_PRODUCT_NAME",
  CREDITS_STRIPE_PRODUCT_DESCRIPTION: "CREDITS_STRIPE_PRODUCT_DESCRIPTION",
  CREDITS_PROJECT_ANALYZED_TOTAL: "CREDITS_PROJECT_ANALYZED_TOTAL",
  CREDITS_EXAMPLES_LABEL: "CREDITS_EXAMPLES_LABEL",
  CREDITS_EXAMPLES_TITLE: "CREDITS_EXAMPLES_TITLE",
  CREDITS_EXAMPLE_CALL: "CREDITS_EXAMPLE_CALL",
  CREDITS_EXAMPLE_OFFER: "CREDITS_EXAMPLE_OFFER",
  CREDITS_EXAMPLE_AVATAR: "CREDITS_EXAMPLE_AVATAR",
  CREDITS_EXAMPLE_CRITERIA: "CREDITS_EXAMPLE_CRITERIA",
  CREDITS_EXAMPLE_SEQUENCE: "CREDITS_EXAMPLE_SEQUENCE",
  CREDITS_EXAMPLE_PROSPECT: "CREDITS_EXAMPLE_PROSPECT",
  CREDITS_EXAMPLE_REPLY: "CREDITS_EXAMPLE_REPLY",
  CREDITS_EXAMPLE_PER_MESSAGE: "CREDITS_EXAMPLE_PER_MESSAGE",
  CREDITS_EXAMPLE_PER_HOUR: "CREDITS_EXAMPLE_PER_HOUR",
  CREDITS_EXAMPLE_PER_VARIANT: "CREDITS_EXAMPLE_PER_VARIANT",
  CREDITS_EXAMPLE_PER_PROSPECT: "CREDITS_EXAMPLE_PER_PROSPECT",
  CREDITS_AUTO_TITLE: "CREDITS_AUTO_TITLE",
  CREDITS_AUTO_TEXT: "CREDITS_AUTO_TEXT",
  CREDITS_AUTO_THRESHOLD: "CREDITS_AUTO_THRESHOLD",
  CREDITS_AUTO_AMOUNT: "CREDITS_AUTO_AMOUNT",
  CREDITS_AUTO_MONTHLY_MAX: "CREDITS_AUTO_MONTHLY_MAX",
  CREDITS_AUTO_USED_THIS_MONTH: "CREDITS_AUTO_USED_THIS_MONTH",
  CREDITS_AUTO_NO_CARD: "CREDITS_AUTO_NO_CARD",
  CREDITS_AUTO_FAILED: "CREDITS_AUTO_FAILED",
  CREDITS_AUTO_ON: "CREDITS_AUTO_ON",
  CREDITS_AUTO_OFF: "CREDITS_AUTO_OFF",
  CREDITS_AUTO_SAVED: "CREDITS_AUTO_SAVED",
  CREDITS_PORTAL: "CREDITS_PORTAL",
} as const;
